import React from "react";
import {
  dateFormatter,
  dateTimeFormatter,
  euroFormatter,
} from "../../../../global";
import TableIconButton from "src/components/UiComponents/Buttons/TableIconButton";
import { faEye as DetailsIcon } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const formatFiscalReceiptNumber = (invoice) => {
  if (!invoice.fiscal_receipt_rep_number || !invoice.fiscal_receipt_number) {
    return null;
  }

  return `${invoice.fiscal_receipt_rep_number}-${invoice.fiscal_receipt_number}`;
};

const AccountingInvoiceRow = ({ invoice, onDetailsClick }) => {
  const { t } = useTranslation();
  const fiscalReceiptNumber = formatFiscalReceiptNumber(invoice);

  return (
    <tr key={invoice.id}>
      <td>
        <div>{invoice.id}</div>
        {invoice.document_type === "refund" && (
          <span className="badge bg-danger text-white">Reso</span>
        )}
      </td>
      <td>{euroFormatter(invoice.total_sum)}</td>
      <td>
        {euroFormatter(invoice.payments.reduce((sum, p) => sum + p.amount, 0))}
      </td>
      <td>{euroFormatter(invoice.open_amount)}</td>
      <td>
        {invoice.status === "paid" ? (
          <span className="badge bg-success text-white">
            {t("accounting.page.filters.status.paid")}
          </span>
        ) : (
          <span className="badge bg-secondary text-white">
            {t("accounting.page.filters.status.unpaid")}
          </span>
        )}
      </td>
      <td>{invoice.paid_at ? dateFormatter(invoice.paid_at) : "-"}</td>
      <td>
        {fiscalReceiptNumber ? (
          <>
            <div>{fiscalReceiptNumber}</div>
            <small className="text-muted">
              {invoice.fiscal_receipt_datetime
                ? dateTimeFormatter(invoice.fiscal_receipt_datetime)
                : "-"}
            </small>
          </>
        ) : (
          "—"
        )}
      </td>
      <td>{dateFormatter(invoice.created_at)}</td>
      <td>
        <div className="d-flex gap-2">
          <TableIconButton
            icon={DetailsIcon}
            variant="primary"
            onClick={() => onDetailsClick(invoice)}
          />
        </div>
      </td>
    </tr>
  );
};

export default AccountingInvoiceRow;
